import { Box, Button, Divider, Grid, IconButton, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Tooltip } from "@mui/material";
import { useContext } from "react";
import { ModalContext } from "../../contexts/ModalContext";
import ModalReport from "../modalReport";

export default function TableDashboard({
	children,
	data,
	enterpriseSelected,
	...props
}) {

	const { handleShow, handleButton, modal } = useContext(ModalContext)
	const total = data[0];
	data = data.filter((el) => el.name != "TOTAL");

	return (
		<>
			<TableContainer
				component={Paper}
				sx={{
					background: "transparent",
					boxShadow: "none",
					overflow: "hidden",
				}}
			>
				<Grid sx={{ borderTop: "3px solid ", borderColor: "#E0EAFF", marginBottom: "24px" }}>
				</Grid>
				<Table sx={{ Width: 20 }} size="small" aria-label="a dense table">
					<TableHead>
						<TableRow>
							<TableCell sx={{ paddingInline: "2px" }}></TableCell>
							<TableCell
								align="center"
								sx={{
									width: "fit-content",
									color: "#2c4992",
									fontWeight: "bold",
									fontSize: "0.850rem",
									paddingInline: "16px",
								}}
							>
								Qtd
							</TableCell>
							<TableCell
								align="right"
								sx={{
									width: "fit-content",
									color: "#2c4992",
									fontWeight: "bold",
									fontSize: "0.850rem",
									paddingInline: "16px",
								}}
							>
								Valor
							</TableCell>
							<TableCell
								align="center"
								sx={{
									width: "fit-content",
									color: "#2c4992",
									fontWeight: "bold",
									fontSize: "0.850rem",
									paddingInline: "2px",
								}}
							>
								%
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.map((e, index) => {
							const porcentNumber = e.pct;
							const porcentClena = parseFloat(porcentNumber);
							const pct = porcentClena.toFixed(1).replaceAll(".", ",");
							return (
								<TableRow
									key={e.name}
									sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
								>
									<TableCell
										align="right"
										component="th"
										scope="row"
										sx={{ fontSize: "0.77rem", paddingInline: "2px" }}
									>
										<Button
											sx={{ fontSize: "0.77rem", padding: 0 }}
											onClick={() => {
												handleShow()
												handleButton({ key: e.name })
											}}
											variant="plain"
										>
											{e.name}
										</Button>
									</TableCell>
									{!!e?.tooltip ?
										<Tooltip title={e?.tooltip}>
											<TableCell
												align="center"
												sx={{
													width: "fit-content",
													fontSize: "0.77rem",
													paddingInline: "2px",
												}}
											>
												{e.qtd}
											</TableCell>
										</Tooltip> :
										<TableCell
											align="center"
											sx={{
												width: "fit-content",
												fontSize: "0.77rem",
												paddingInline: "2px",
											}}
										>
											{e.qtd}
										</TableCell>
									}
									<TableCell
										align="right"
										sx={{
											width: "fit-content",
											fontSize: "0.77rem",
											paddingInline: "16px",
										}}
									>
										{e.val}
									</TableCell>
									<TableCell
										align="center"
										sx={{
											width: "fit-content",
											fontSize: "0.77rem",
											paddingInline: "16px",
										}}
									>
										{pct}
									</TableCell>
								</TableRow>
							);
						})}
						<TableRow>
							<TableCell
								align="right"
								sx={{
									width: "fit-content",
									fontWeight: "bold",
									paddingInline: "2px",
									fontSize: "0.77rem",
									borderTop: "2px solid black",
								}}
							>
								TOTAL
							</TableCell>
							<TableCell
								align="right"
								sx={{
									width: "fit-content",
									fontWeight: "bold",
									paddingInline: "2px",
									fontSize: "0.77rem",
									borderTop: "2px solid black",
								}}
							></TableCell>
							<TableCell
								align="center"
								sx={{
									width: "fit-content",
									fontWeight: "bold",
									paddingInline: "2px",
									fontSize: "0.77rem",
									borderTop: "2px solid black",
								}}
							>
								R$ {total.val}
							</TableCell>
							<TableCell
								align="center"
								sx={{
									width: "fit-content",
									fontWeight: "bold",
									paddingInline: "2px",
									fontSize: "0.77rem",
									borderTop: "2px solid black",
								}}
							></TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
			{modal && <ModalReport />}
		</>
	);
}
